














































































































import { Component, Prop, Mixins } from "vue-property-decorator";
import _ from "@/boot/lodash";

// Mixins
import ImportInjectorMixin from "@/mixins/importInjectorMixin";

// Enums/Data
import { ImportStatuses } from "@/data/status";
import {
  ImportStatusCodes as ISC,
  ImportStepCodes,
  ImportStatusMap
} from "@/data/enums/imports";

// Types
import { IImportStep } from "@/models/imports";

@Component({
  components: {
    "import-step-body": () =>
      import("@/components/app/admin/imports/importStepBody.vue")
  }
})
export default class ImportStepVessel extends Mixins(ImportInjectorMixin) {
  // Props

  @Prop({ required: true })
  public readonly step!: IImportStep;

  // Methods

  public onClick() {
    if (!this.showStagedRecords) return;

    this.$importMethods.openStagedRecordsModal(this.step);
  }

  // Computed

  public get showStagedRecords() {
    const mappedStatuses = [
      ImportStepCodes.PRODUCTS,
      ImportStepCodes.CLIENTS,
      ImportStepCodes.AFFILIATE_ACCOUNTS,
      ImportStepCodes.USERS,
      ImportStepCodes.CLIENT_PAYMENT_DETAILS,
      ImportStepCodes.CONTRACTS,
      ImportStepCodes.INVOICES,
      ImportStepCodes.TICKETS
    ];

    return (
      [ISC.STAGED, ISC.COMPLETE].includes(this.step.status.code) &&
      this.step.total_count > 0 &&
      mappedStatuses.includes(this.step.code)
    );
  }

  public get isExpandable() {
    const statuses = _.compact([
      ISC.PENDING,
      ISC.COMPLETE,
      ISC.CANCELLED,
      ISC.ERROR,
      ISC.STEP_SKIPPED,
      ISC.STAGED
    ]) as ISC[];

    if (statuses.includes(this.importStatusCode)) return false;
    return !statuses.includes(this.stepStatusCode);
  }

  public get importIsCancelled() {
    return [ISC.CANCELLED].includes(this.importStatusCode);
  }

  public get importCancelledState() {
    return ISC.CANCELLED;
  }

  public get importCancelledLabel() {
    return this.$t("_.cancelled");
  }

  public get isSkipped() {
    return [ISC.STEP_SKIPPED].includes(this.stepStatusCode);
  }

  public get isPending() {
    return [ISC.PENDING].includes(this.stepStatusCode);
  }

  public get hasError() {
    return [ISC.ERROR].includes(this.stepStatusCode);
  }

  public get stepSummary() {
    const map = ImportStatusMap()[
      this.importIsCancelled
        ? ISC.CANCELLED
        : this.isCSVDataImport &&
          this.stepIsActive &&
          [ISC.PENDING].includes(this.stepStatusCode)
        ? ISC.READY
        : this.stepStatusCode
    ];
    return this.$_.get(map, "summary", () => "")(this.step);
  }

  public get showProgress() {
    return [ISC.EXPORTING, ISC.IN_PROGRESS].includes(this.stepStatusCode);
  }

  public get stepType() {
    return this.$_.get(ImportStatuses[this.stepStatusCode], "type", "");
  }

  public get showBody() {
    return this.isExpandable || this.isCSVExpandable;
  }

  public get isCSVExpandable() {
    return (
      this.isCSVDataImport &&
      this.stepIsActive &&
      this.importStatusCode !== ISC.CANCELLED
    );
  }

  public get importStatusCode() {
    return this.$importData.import.status.code;
  }

  public get stepStatusCode() {
    return this.step.status.code;
  }

  public get isCSVDataImport() {
    return this.$importData.isCVSDataImport;
  }

  public get stepIsActive() {
    if ([ISC.CANCELLED, ISC.COMPLETE].includes(this.importStatusCode))
      return false;

    const steps = this.$importData.steps;
    const stepsNeedProcessing = _.orderBy(
      _.filter(steps, step => step.status.code === ISC.PENDING),
      ["order", "asc"]
    );

    // Starting point
    if (stepsNeedProcessing.length === steps.length)
      return this.step.order === 0;

    return [
      ISC.READY,
      ISC.MAPPINGS_REQUIRED,
      ISC.EXPORTING,
      ISC.IN_PROGRESS
    ].includes(this.stepStatusCode);
  }

  public get isWaitingContinuation() {
    return this.stepStatusCode === ISC.READY;
  }

  public get showReset() {
    if (!this.$importData.canResetStep || !this.isCSVDataImport) return false;

    const resetStatuses = [ISC.ERROR, ISC.MAPPINGS_REQUIRED];
    if (resetStatuses.includes(this.stepStatusCode)) return true;

    return false;
  }

  public get vesselClass() {
    if (this.importIsCancelled) return "";

    return [
      (this.isExpandable || this.isCSVExpandable || this.showStagedRecords) &&
        "is-expandable",
      this.showStagedRecords && `has-header-linked`
    ];
  }

  public get showEmptyIcon() {
    const completeWithRecords = _.some(
      this.$importData.steps,
      step => step.total_count > 0
    );

    return !this.importIsCancelled && completeWithRecords;
  }
}
